var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import * as Styled from "./MenuStyles";
var Menu = React.forwardRef(function (_a, ref) {
    var items = _a.items, onClick = _a.onClick, props = __rest(_a, ["items", "onClick"]);
    return (React.createElement(Styled.Menu, __assign({ onClick: onClick }, props, { ref: ref }), items.map(function (item, index) { return (React.createElement(Styled.MenuItem, { key: index }, item)); })));
});
export default Menu;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiTWVudS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIk1lbnUudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7QUFBQSxPQUFPLEtBQW9CLE1BQU0sT0FBTyxDQUFDO0FBQ3pDLE9BQU8sS0FBSyxNQUFNLE1BQU0sY0FBYyxDQUFDO0FBU3ZDLElBQU0sSUFBSSxHQUF3QixLQUFLLENBQUMsVUFBVSxDQUNoRCxVQUFDLEVBQTRCLEVBQUUsR0FBRztJQUEvQixJQUFBLEtBQUssV0FBQSxFQUFFLE9BQU8sYUFBQSxFQUFLLEtBQUssY0FBMUIsb0JBQTRCLENBQUY7SUFDekIsT0FBTyxDQUNMLG9CQUFDLE1BQU0sQ0FBQyxJQUFJLGFBQUMsT0FBTyxFQUFFLE9BQU8sSUFBTSxLQUFLLElBQUUsR0FBRyxFQUFFLEdBQUcsS0FDL0MsS0FBSyxDQUFDLEdBQUcsQ0FBQyxVQUFDLElBQUksRUFBRSxLQUFLLElBQUssT0FBQSxDQUMxQixvQkFBQyxNQUFNLENBQUMsUUFBUSxJQUFDLEdBQUcsRUFBRSxLQUFLLElBQUcsSUFBSSxDQUFtQixDQUN0RCxFQUYyQixDQUUzQixDQUFDLENBQ1UsQ0FDZixDQUFDO0FBQ0osQ0FBQyxDQUNGLENBQUM7QUFFRixlQUFlLElBQUksQ0FBQyJ9